import gql from 'graphql-tag';

export const QUERY_PARTNER_CONTACTS = gql`
  query CMS_Partner_Contacts(
    $pageSize: Int
    $pageNumber: Int
    $phoneNumber: NonEmptyString
    $partnerReferrerId: ID
    $partnerCode: NonEmptyString
    $partnerName: NonEmptyString
    $partnerTypes: [PartnerType]
    $sortBy: PartnerContactSortBy
    $sortDirection: SortDirection
    $createdAfter: Date
    $createdBefore: Date
    $countries: [PartnerCountryType]
    $emailAddress: NonEmptyString
    $enables: [Boolean]
  ) {
    partnerContacts(
      countries: $countries
      emailAddress: $emailAddress
      pageSize: $pageSize
      pageNumber: $pageNumber
      phoneNumber: $phoneNumber
      partnerReferrerId: $partnerReferrerId
      partnerCode: $partnerCode
      partnerName: $partnerName
      partnerTypes: $partnerTypes
      sortBy: $sortBy
      sortDirection: $sortDirection
      createdAfter: $createdAfter
      createdBefore: $createdBefore
      enables: $enables
    ) {
      totalCount
      pageInfo {
        numPages
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          id
          phoneNumber
          emailAddress
          createdAt
          updatedAt
          enabled
          partner {
            id
            name
            code
            country
            type
            originCountry {
              name
            }
            payoutPlan {
              name
            }
            commissionPlan {
              name
            }
            internalReferrer {
              id
              firstName
              lastName
            }
          }
        }
      }
    }
  }
`;

export const QUERY_PARTNER_CONTACT = gql`
  query CMS_Partner_Contact($partnerReferrerId: ID, $partnerCode: NonEmptyString) {
    partnerContacts(partnerReferrerId: $partnerReferrerId, partnerCode: $partnerCode) {
      edges {
        node {
          id
          phoneNumber
          emailAddress
          referralLead
          agentMode
          certificationSign {
            certificationStatus
            signStatus
          }
          city {
            id
            name
            state {
              name
            }
            country {
              name
            }
          }
          partner {
            id
            name
            code
            type
            originCountry {
              name
              countryCode
              slug
            }
            payoutPlan {
              name
              default
              bookingCompletedPercent
              bookingPaidPercent
            }
            currentTierId
            currentTier {
              name
            }
            commissionPlan {
              id
              name
              externalName
              default
              currency
              tiers {
                name
                bookingCountFrom
                bookingCountTo
                longTermCalculationValue
                shortTermCalculationValue
                calculationRules {
                  leaseType
                  tenancyLengthFrom
                  tenancyLengthTo
                  calculationValue
                  calculationType
                }
              }
            }
            internalReferrer {
              id
              firstName
              lastName
            }
            withdrawAmountAggregation {
              remainWithdraw
              currency
            }
            paymentPreference
          }
        }
      }
    }
  }
`;

export const MUTATION_MODIFY_PARTNER_COMMISSION_PLAN = gql`
  mutation MODIFY_PARTNER_COMMISSION_PLAN($commissionPlanId: ID!, $partnerId: ID!) {
    modifyPartnerCommissionPlanId(
      input: { commissionPlanId: $commissionPlanId, partnerId: $partnerId }
    ) {
      result
    }
  }
`;

export const QUERY_LIST_REFERRERS = gql`
  query listReferrers($nameLike: String, $pageSize: Int, $pageNumber: Int) {
    referrers(nameLike: $nameLike, pageSize: $pageSize, pageNumber: $pageNumber) {
      totalCount
      edges {
        node {
          id
          firstName
          lastName
        }
      }
    }
  }
`;

export const MUTATION_BULK_REASSIGN_REFERRER = gql`
  mutation bulkReassignReferrer($partnerIds: [ID!]!, $referrerId: ID) {
    bulkReassignReferrer(input: { partnerIds: $partnerIds, referrerId: $referrerId }) {
      result
    }
  }
`;

export const MUTATION_UPDATE_INDIVIDUAL_PARTNER_CONTACT = gql`
  mutation updateIndividualPartnerContact(
    $id: ID!
    $cityId: NonEmptyString
    $referralLead: Boolean
    $agentMode: Boolean
  ) {
    updateIndividualPartnerContact(
      data: { cityId: $cityId, referralLead: $referralLead, agentMode: $agentMode }
      id: $id
    ) {
      result
    }
  }
`;

export const QUERY_COUNTRIES = gql`
  query CMS_CountriesView(
    $pageNumber: Int!
    $pageSize: Int!
    $countrySlugs: [String!]
    $billingCycle: [BillingCycle!]
    $sortBy: CountrySortBy
    $sortDirection: SortDirection
    $publishedStatus: NodePublishedFilter
  ) {
    countries(
      pageNumber: $pageNumber
      pageSize: $pageSize
      countrySlugs: $countrySlugs
      billingCycle: $billingCycle
      sortBy: $sortBy
      sortDirection: $sortDirection
      publishedStatus: $publishedStatus
    ) {
      edges {
        node {
          id
          name
          cities {
            edges {
              node {
                id
                name
              }
            }
          }
          states {
            edges {
              node {
                id
                name
                cities {
                  edges {
                    node {
                      id
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
